declare var jsonloginData: any;

export const hasRole = (role: string): boolean => {
  const userRoles: string[] = jsonloginData.fLoginRoles;
  return userRoles.indexOf(role) > -1;
};

export const hasAnyRole = (roleList: string[]): boolean => {
  return roleList.some(role => hasRole(role));
};